<style lang="less">
.process {
  padding-right: 20px;
  padding-left: 20px;
  height: calc(100vh - 64px);
  padding-bottom: 20px;
  overflow: scroll;
  .nav--top {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    height: 137px;
    padding-left: 20px;
    margin-top: 16px;
    background-color: #fff;
  }

  .back {
    cursor: pointer;
    font-size: 14px;
    margin-top: 23px;
    margin-bottom: 17px;
    display: flex;
    .icon {
      margin-right: 8px;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url("../home/back.png") no-repeat 0 50%;
      background-size: 100%;
    }
  }
  .steps{
    display: flex;
    justify-content:center;
    margin-top: -22px;
    .step__box{
      max-width: 742px;
    }
    .ant-steps{
      overflow-x: auto;
      .ant-steps-item{
        .ant-steps-item-tail{
          top: 16px;
          padding: 3.5px 42px;
        }
        .ant-steps-item-icon{
          width: 40px;
          height: 40px;
          line-height: 40px;
          margin-left: 30px;
          font-size: 15px;
        }
        .ant-steps-item-content{
          margin-top: 20px;
          .ant-steps-item-title{
            font-size: 14px;
            line-height: 22px;
          }
          .ant-steps-item-description{
            .time{
              font-size: 12px;
              color: rgba(0,0,0,.45);
              line-height: 20px;
              height: 40px;
              overflow: hidden;
              margin: 2px 0 4px 0;
            }
          }
        }
      }
      .ant-steps-item-finish,.ant-steps-item-process{
        .ant-steps-item-title{
          color: #FC8830;
        }
      }
    }
  }
  .content{
    margin-top: 10px;
    padding-bottom: 72px;
  }
}
</style>
<template>
  <div class="process">
    <div class="nav--top">
      <div class="back" @click="goBack">
        <span class="icon"></span><b>返回</b>
      </div>
      <div class="steps">
        <a-steps class="step__box" labelPlacement="vertical" :current="currentStep">
        <a-step
          :status="step.status"
          :key="index"
          v-for="(step, index) in steps"
        >
          <span slot="title">{{ step.desc }}</span>
        </a-step>
      </a-steps>
      </div>
    </div>
    <router-view class="content"></router-view>
  </div>
</template>
<script>
export default {
  mounted () {},
  data () {
    return {
      currentStep: 0
    }
  },
  computed: {
    steps () {
      const steps = [
        { desc: '确认订单', status: 'process', key: 'confirm' },
        { desc: '选择支付方式', status: 'wait', key: 'paying' },
        { desc: '完成支付', status: 'wait', key: 'done' }
      ]
      const highlightCount = {
        paying: 0,
        done: 1,
        finish: 2
      }[this.$route.name]
      for (let i = 0; i <= highlightCount; i++) {
        steps[i].status = 'finish'
        if (steps[i + 1]) {
          steps[i + 1].status = 'process'
        }
      }
      return steps
    }
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/pay',
        query: this.$route.query
      })
    }
  }
}
</script>
